// API Configuration
// Automatically detects the correct backend URL based on the current environment

const getApiUrl = () => {
  // In production, use the same origin (the backend is served from the same domain)
  // In development/preview, use the environment variable
  
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  
  // If we're on a custom domain (not preview.emergentagent.com), use the same origin
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;
    
    // If on custom domain (production), use same origin
    if (!currentHost.includes('preview.emergentagent.com') && !currentHost.includes('localhost')) {
      return window.location.origin;
    }
  }
  
  // Otherwise use the environment variable (preview/dev)
  return envUrl || '';
};

export const API_URL = getApiUrl();
export default API_URL;
